import { IS_AUTO_TEST_HIDE } from 'reactApp/appHelpers/configHelpers';
import { vigboTariffEndModal, vigboTariffs } from 'reactApp/appHelpers/featuresHelpers/features/vigbo';
import { handleBillingDataSuccess } from 'reactApp/modules/billingData/billingData.handler.saga';
import { getLatestExpiredSubscription } from 'reactApp/modules/billingData/billingData.helpers';
import { getBillingDataRequestIfNotLoaded } from 'reactApp/modules/billingData/billingData.module';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { pastSubscriptionsRequest } from 'reactApp/modules/pastSubscriptions/pastSubscriptions.module';
import { handlePastSubscriptionsSuccess } from 'reactApp/modules/pastSubscriptions/pastSubscriptions.saga';
import { PastSubscriptionsSelectors } from 'reactApp/modules/pastSubscriptions/pastSubscriptions.selectors';
import { getPaySource } from 'reactApp/modules/payment/payment.analytics';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { productsController } from 'reactApp/modules/products/products.controller';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { getVigboProductIdByTrial } from 'reactApp/modules/vigbo/vigbo.helpers';
import { hasActiveVigboTariff } from 'reactApp/modules/vigbo/vigbo.selectors';
import { store } from 'reactApp/store';
import { VigboWhatsNewPropsBuilder } from 'reactApp/ui/VigboWhatsNew/VigboWhatsNew.builder';
import { closeVigboWhatsNew, renderVigboWhatsNew } from 'reactApp/ui/VigboWhatsNew/VigboWhatsNew.helpers';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { call, put, select } from 'typed-redux-saga';

const PROMO_ID = 'vigbo-tariff-end';

export function* initVigboTariffEnd() {
    const storage = yield* select(getCurrentStorage);
    const { isHome, isVigbo } = getStorage(storage);
    const isMobile = yield* select(EnvironmentSelectors.isMobile);
    const isCorpUser = yield* select(UserSelectors.isCorpUser);
    const isBizUser = yield* select(UserSelectors.isBizUser);
    const isSocialUser = yield* select(UserSelectors.isSocialUser);

    // показываем на /home и на /vigbo
    // скрываем на автотестых и таче
    // исключаем корпов, бизов и соцников
    // Скрываем под фичей
    if (
        !(isHome || isVigbo) ||
        IS_AUTO_TEST_HIDE ||
        isMobile ||
        isCorpUser ||
        isBizUser ||
        isSocialUser ||
        !vigboTariffEndModal ||
        storeHelper.getValue(PROMO_ID)
    ) {
        return;
    }

    yield* put(pastSubscriptionsRequest());
    const pastSubsSuccessLoad = yield* handlePastSubscriptionsSuccess();
    if (!pastSubsSuccessLoad) {
        return;
    }

    const vigboPastSubs = yield* select(PastSubscriptionsSelectors.getPastSubscriptionsByProductIds, vigboTariffs);
    const latestExpireTariff = getLatestExpiredSubscription(vigboPastSubs);
    if (!latestExpireTariff) {
        return;
    }

    /** Можем позволить нагло сходить второй раз в billing/data, потому что ответ от нее в кэше */
    yield* put(getBillingDataRequestIfNotLoaded());
    const currentSubsSuccessLoad = yield* handleBillingDataSuccess();
    if (!currentSubsSuccessLoad) {
        return;
    }

    const isVigboActiveTariff = yield* select(hasActiveVigboTariff);
    if (isVigboActiveTariff) {
        return;
    }

    const productId = latestExpireTariff.isTrial ? getVigboProductIdByTrial(latestExpireTariff) : latestExpireTariff.productId;
    const product = yield* call(productsController.updateProducts, productId);
    if (!product || !product.available) {
        return;
    }

    const isOverquota = yield* select(UserQuotaSelectors.isOverquota);

    const onModalClose = () => {
        store.dispatch(removePromo(EPromoType.vigboTariffEnd));
    };

    yield* put(
        addPromoToShowQueue({
            promoId: PROMO_ID,
            type: EPromoType.vigboTariffEnd,
            isOverquota,
            product,
            onClose: onModalClose,
            onShow: () => {
                sendPaymentGa({
                    eventCategory: ECategoryGa.vigbo,
                    action: 'show-communication-end-sub',
                });

                storeHelper.markAsShown(PROMO_ID);
                store.dispatch(promoShown(EPromoType.vigboTariffEnd));
            },
            onClick: () => {
                sendPaymentGa({
                    eventCategory: ECategoryGa.vigbo,
                    action: 'click-communication-end-sub',
                });

                store.dispatch(
                    openTariffBuy({
                        productId: product.id,
                        paySource: getPaySource(PROMO_ID),
                        vigboSkipRedirect: true,
                        onClose: () => {
                            onModalClose();
                            closeVigboWhatsNew();
                        },
                    })
                );
            },
        })
    );
}

export function* showVigboTariffEnd() {
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.vigboTariffEnd));

    if (!promo) {
        return;
    }

    /** Собираем пропсы на основе данных из промо */
    const { product, isOverquota, onClick, onClose, onShow } = promo;
    const props = VigboWhatsNewPropsBuilder.endTariff(product, isOverquota, onClick, onClose, onShow);

    renderVigboWhatsNew(props);
}
